import React, { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

interface TabContentProps {
  tabTitle: string
  tabContent: ReactNode
  tabCategory?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  passedData?: any
}
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )
}

export default function FaberBasicTab({
  tabInfo
}: {
  tabInfo: TabContentProps[]
}) {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
          TabIndicatorProps={{
            style: { backgroundColor: 'transparent' }
          }}
          sx={{
            display: 'flex',
            '.MuiTabs-flexContainer': {
              gap: 1,
              px: 1,
              py: 1
            }
          }}
        >
          {tabInfo.map((info, index) => (
            <Tab
              sx={{
                transition: '0.5s',
                color: '#151D29',
                boxShadow: '0px 2px 5px 0px #111EBE33',
                borderRadius: '24px',
                backgroundColor: '#F5F7FA',
                fontSize: '0.7em',
                padding: `8px 12px`,
                minHeight: '20px',
                '&.Mui-selected': {
                  backgroundColor: '#1400B8',
                  color: '#F5F7FA'
                }
              }}
              component={Link}
              key={`content-tab-${index}=${info.tabTitle}`}
              label={info.tabTitle}
              to={`#${info?.tabCategory}`}
              state={info?.passedData}
            />
          ))}
        </Tabs>
        {tabInfo.map((info, index) => (
          <TabPanel
            key={`${info.tabContent}-${index}`}
            value={value}
            index={index}
          >
            {info.tabContent}
          </TabPanel>
        ))}
      </Box>
    </Box>
  )
}
